import moment from "moment";

export function getGIAPaliersDates(dateDebutEvenement) {
    const event = moment(dateDebutEvenement);
    return {
        j40: event.clone().subtract(40, "days"),
        j20: event.clone().subtract(20, "days"),
        j5: event.clone().subtract(5, "days"),
    };
}

export function getGIARemboursementRate(dateDebutEvenement, referenceDate = moment()) {
    const currentDate = moment(referenceDate).startOf("day");
    const { j40, j20, j5 } = getGIAPaliersDates(dateDebutEvenement);

    if (currentDate.isAfter(j5, "day")) {
        return 0;
    }
    if (currentDate.isAfter(j20, "day")) {
        return 0.5;
    }
    if (currentDate.isAfter(j40, "day")) {
        return 0.7;
    }
    return 1;
}

export function computeGIAAmountRefundable(montant, dateDebutEvenement, referenceDate = moment()) {
    const rate = getGIARemboursementRate(dateDebutEvenement, referenceDate);
    return parseFloat((parseFloat(montant) * rate).toFixed(2));
}

function formatGIADate(date) {
    return moment(date).format("D MMMM YYYY");
}

export function getGIAConditionsAffichage(dateDebutEvenement) {
    const { j40, j20, j5 } = getGIAPaliersDates(dateDebutEvenement);

    return {
        conditions: [
            { label: `Jusqu'au ${formatGIADate(j40)} inclus`, rate: 100 },
            { label: `Jusqu'au ${formatGIADate(j20)} inclus`, rate: 70 },
            { label: `Jusqu'au ${formatGIADate(j5)} inclus`, rate: 50 },
        ],
        dateFinRemboursement: formatGIADate(j5),
    };
}

export function isGIARemboursementExpired(dateDebutEvenement, referenceDate = moment()) {
    return getGIARemboursementRate(dateDebutEvenement, referenceDate) === 0;
}
